module.exports = __webpack_public_path__ + "img/trophy_0002_lightbulb.621f1746.png";